








































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Lists from './Service/AccountLists';
import manageForm from '@/modules/FPKG-40000-Account/manage/form';

@Component({
  components: {},
})
export default class accountLists extends Vue {
  private manageForm = manageForm;

  private paginator: number = 1;

  private tableData: Array<object> = [];

  private search = {
    search_complex: '',
  };

  /** pushAccount */
  private pushAccount(data: any) {
    this.$emit('pushAccount', data);
  }

  /** 取得列表 */
  public async getLists(params?: object) {
    const getter = (await new Lists(params).get()) as any;
    this.tableData = getter.list;
    this.paginator = getter.paginator.page ? getter.paginator.page : 1;
  }

  // eslint-disable-next-line camelcase
  get page_num() {
    const store = this.$store.getters;
    if (
      store &&
      store.getList &&
      store.getList.paginator &&
      store.getList.paginator.page_num
    ) {
      return store.getList.paginator.page_num;
    }
    return 1;
  }

  public submitPage(feature: string) {
    let page = this.paginator;
    const num = this.page_num;
    let query: any = { ...this.search, page };
    switch (feature) {
      case 'goPage':
        query = { ...this.search, page };
        this.getLists(query);
        break;
      case 'firstPage':
        page = 1;
        query = { ...this.search, page };
        this.getLists(query);
        break;
      case 'prevPage':
        page = page - 1 > 1 ? page - 1 : 1;
        query = { ...this.search, page };
        this.getLists(query);
        break;
      case 'nextPage':
        page = Number(page) + 1 > num ? num : Number(page) + 1;
        query = { ...this.search, page };
        this.getLists(query);
        break;
      case 'lastPage':
        page = this.page_num;
        query = { ...this.search, page: this.page_num };
        this.getLists(query);
        break;
      case 'search':
        query = { ...this.search, page: 1 };
        this.getLists(query);
        break;
      default:
        break;
    }
    this.getLists(query);
  }

  public async mounted() {
    this.getLists();
  }
}
